// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UnifiedProfileSubpages = require("./UnifiedProfileSubpages.bs.js");
let UnifiedProfileConversion = require("./UnifiedProfileConversion.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let UnifiedProfilePublicActions = require("./UnifiedProfilePublicActions.bs.js");
let UnifiedAccountProfileUrlSettings = require("./UnifiedAccountProfileUrlSettings.bs.js");
let UnifiedAccountProfileSettingsQuery_graphql = require("../../__generated__/UnifiedAccountProfileSettingsQuery_graphql.bs.js");

let convertVariables = UnifiedAccountProfileSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedAccountProfileSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedAccountProfileSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UnifiedAccountProfileSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedAccountProfileSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedAccountProfileSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedAccountProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedAccountProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedAccountProfileSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedAccountProfileSettings(props) {
  let match = use(undefined, undefined, undefined, undefined);
  let account = match.currentAccountV5;
  let profile = account.profile;
  let match$1;
  switch (profile.__typename) {
    case "IndividualAccountProfile" :
      match$1 = [
        "Individual",
        "Individual profile",
        profile.agent.displayName,
        profile.publicUrl
      ];
      break;
    case "TeamAccountProfile" :
      match$1 = [
        "Team",
        "Team profile",
        profile.teamName,
        profile.publicUrl
      ];
      break;
    case "__unselected" :
      match$1 = UnselectedUnionMemberError.raise(`Unselected account profile member: ` + profile._0);
      break;
  }
  let profileType = match$1[0];
  let pages = UnifiedProfileSubpages.accountProfilePages(profileType);
  let accountProfileName = UnifiedProfileSubpages.accountProfileName(profileType);
  let match$2 = account.profile;
  let tmp;
  switch (match$2.__typename) {
    case "IndividualAccountProfile" :
      tmp = Stdlib_Option.map(match$1[3], Scalars.URL.toString);
      break;
    case "TeamAccountProfile" :
    case "__unselected" :
      tmp = undefined;
      break;
  }
  let match$3 = account.profile;
  let tmp$1;
  switch (match$3.__typename) {
    case "TeamAccountProfile" :
      tmp$1 = JsxRuntime.jsx(UnifiedProfilePublicActions.make, {
        account: account.fragmentRefs
      });
      break;
    case "IndividualAccountProfile" :
    case "__unselected" :
      tmp$1 = null;
      break;
  }
  let tmp$2;
  tmp$2 = profileType === "Individual" ? JsxRuntime.jsx(UnifiedAccountProfileUrlSettings.make, {
      inline: true
    }) : JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("h3", {
              children: match$1[2],
              className: "text-2xl font-medium leading-6 text-zinc-800"
            }),
            JsxRuntime.jsx("p", {
              children: "Choose a section to update the account's public profile.",
              className: "text-base text-zinc-500"
            })
          ],
          className: "space-y-2"
        }),
        JsxRuntime.jsx("div", {
          children: pages.map(page => JsxRuntime.jsx(UnifiedProfileSettingsUI.SettingsLink.make, {
            name: page.name,
            description: page.description,
            url: page.url
          }, page.url)),
          className: "space-y-4"
        })
      ],
      className: "space-y-6"
    });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UnifiedProfileSettingsUI.Header.make, {
        title: accountProfileName,
        description: "Manage how this account is presented publicly, including its public URL and team-level information.",
        profileKind: match$1[1],
        publicUrl: tmp,
        actions: tmp$1
      }),
      tmp$2,
      JsxRuntime.jsx(UnifiedProfileConversion.make, {
        profileType: profileType
      })
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = UnifiedAccountProfileSettings;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
